import { computed } from 'vue'

import type { DashboardStoreValuesType } from '@/features/ui/pages/dashboard/stores/dashboard/dashboard.store'

export function selectGetSelectedGroupId(state: DashboardStoreValuesType) {
  return computed(() => state.selectedGroupId)
}
